import { render, staticRenderFns } from "./DCLink.vue?vue&type=template&id=a3e99fba"
import script from "./DCLink.vue?vue&type=script&lang=js"
export * from "./DCLink.vue?vue&type=script&lang=js"
import style0 from "./DCLink.vue?vue&type=style&index=0&id=a3e99fba&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports